// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1fuhk","author":"Table_author__3JrV_","authorImage":"Table_authorImage__12LlF","unreadRow":"Table_unreadRow___O5_O"};